import { ref } from "vue"

export function useDialog() {
    const showDialog = ref(false)
    function onShowDialog() {
        showDialog.value = true
    }
    function onCloseDialog() {
        showDialog.value = false
    }
    return {
        showDialog,
        onShowDialog,
        onCloseDialog,
    }
}
